import React from 'react';
import { Link } from 'react-router-dom';
type Variant = 'primary' | 'secondary' | 'ghost';
interface ButtonProps {
  to?: string;
  href?: string;
  onClick?: () => void;
  variant?: Variant;
  children: React.ReactNode;
  className?: string;
  type?: 'button' | 'submit';
}
const base = 'inline-flex items-center justify-center gap-2 rounded-brand px-7 py-3.5 text-sm font-medium transition-colors duration-150 ease-brand';
const variants: Record<Variant, string> = {
  // Terracotta fill — the single loudest element on any screen.
  primary: 'bg-brick text-cream hover:bg-brick-deep',
  // Ink hairline that fills to ink on hover.
  secondary: 'border border-ink/30 text-ink hover:border-ink hover:bg-ink hover:text-cream',
  // For use on the plum night band: cream hairline that fills to cream.
  ghost: 'border border-cream/40 text-cream hover:bg-cream hover:text-ink'
};
export function Button({
  to,
  href,
  onClick,
  variant = 'primary',
  children,
  className = '',
  type = 'button'
}: ButtonProps) {
  const classes = `${base} ${variants[variant]} ${className}`;
  if (to) {
    return <Link to={to} className={classes} data-id="element-355" data-mp="eqfvpa1cnozo">
        {children}
      </Link>;
  }
  if (href) {
    return <a href={href} className={classes} data-id="element-356" data-mp="tnye7unfp5yo">
        {children}
      </a>;
  }
  return <button type={type} onClick={onClick} className={classes} data-id="element-357" data-mp="onkfx4bmxadu">
      {children}
    </button>;
}